module.exports = __webpack_public_path__ + "08637d489762b6209403486684698723.png";